// Mutations
export const toggleSearch = (state, payload) => {
	state.showSearch = payload
}

export const searchTerm = (state, payload) => {
	state.searchTerm = payload
}

export const entries = (state, payload) => {
	state.entries = payload
}

export const standards = (state, payload) => {
	state.standards = payload.data
}

export const standardsSearchTerm = (state, payload) => {
	state.standardsSearchTerm = payload
}

export const filteredStandards = (state, payload) => {
	state.filteredStandards = payload
}

export const sortOrder = (state, payload) => {
	state.sortOrder = payload
}

export const sortKey = (state, payload) => {
	state.sortKey = payload
}

export const showWithdrawn = (state, payload) => {
	state.showWithdrawn = payload
}

export const members = (state, payload) => {
	state.members = payload
}

export const main_menu = (state, payload) => {
	state.main_menu = payload
}

export const main_menu_flat = (state, payload) => {
	state.main_menu_flat = payload
}

export const categories = (state, payload) => {
	state.categories = payload
}